import React from "react";
import { NavLink } from "react-router-dom";

const slides = [
  {
    id: "newyear",
    badge: "🔥 Promo Terbatas",
    title: "Diskon sampai 60% untuk Template & Asset Premium",
    desc: "Buat landing page, desain, dan project lebih cepat. Instant download, akses selamanya.",
    img: "/assets/main.png.jpg",
    primaryTo: "/product?promo=60",
    primaryText: "Ambil Promo",
    secondaryTo: "/product",
    secondaryText: "Lihat Semua Produk",
    perks: ["⚡ Instant download", "🔒 Pembayaran aman", "♻️ Akses selamanya", "✅ Update gratis*"],
  },
  {
    id: "bundle",
    badge: "🎁 Bundle Deal",
    title: "Paket Hemat: Template + Ebook + Source Code",
    desc: "Cocok untuk bisnis, desain, dan developer. Sekali beli, pakai berkali-kali.",
    img: "/assets/main.png.jpg",
    primaryTo: "/product?cat=bundle",
    primaryText: "Lihat Bundle",
    secondaryTo: "/product?cat=free",
    secondaryText: "Cek Freebies",
    perks: ["📦 Bundle lebih hemat", "🧩 Siap pakai", "🛠️ Cocok untuk dev", "✨ Desain modern"],
  },
  {
    id: "freebies",
    badge: "🆓 Freebies",
    title: "Mulai dari yang Gratis dulu",
    desc: "Download freebies untuk coba kualitasnya. Kalau cocok, lanjut ambil versi premiumnya.",
    img: "/assets/main.png.jpg",
    primaryTo: "/product?cat=free",
    primaryText: "Lihat Freebies",
    secondaryTo: "/product",
    secondaryText: "Explore Premium",
    perks: ["🆓 Gratis", "⚡ Cepat", "📁 Rapih", "💡 Inspiratif"],
  },
];

function clampIndex(i, len) {
  return (i + len) % len;
}

const PromoBannerSlider = ({ items = slides, interval = 6000 }) => {
  const [active, setActive] = React.useState(0);
  const [paused, setPaused] = React.useState(false);

  React.useEffect(() => {
    if (paused || items.length <= 1) return;
    const t = setInterval(() => setActive((v) => clampIndex(v + 1, items.length)), interval);
    return () => clearInterval(t);
  }, [paused, items.length, interval]);

  const goPrev = () => setActive((v) => clampIndex(v - 1, items.length));
  const goNext = () => setActive((v) => clampIndex(v + 1, items.length));

  return (
    <div
      className="relative w-full overflow-hidden bg-white/5 shadow-2xl rounded-none sm:rounded-3xl sm:border sm:border-white/10"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      {/* Slides */}
      <div
        className="flex transition-transform duration-700 ease-out"
        style={{ transform: `translateX(-${active * 100}%)` }}
      >
        {items.map((s) => (
          <div key={s.id} className="relative min-w-full">
            {/* Full-bleed background */}
            <div className="relative h-[420px] w-full sm:h-[520px]">
              <img
                src={s.img}
                alt={s.title}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover object-right"
              />

              {/* Overlays */}
              <div
                aria-hidden="true"
                className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/55 to-black/15"
              />
              <div
                aria-hidden="true"
                className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-emerald-500/15 blur-3xl"
              />
              <div
                aria-hidden="true"
                className="pointer-events-none absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/40 to-transparent"
              />
              {/* Extra right-side glow to avoid “empty right” */}
              <div
                aria-hidden="true"
                className="pointer-events-none absolute inset-0 bg-[radial-gradient(60%_60%_at_80%_30%,rgba(16,185,129,0.20),transparent_60%)]"
              />

              {/* Content (container only) */}
              <div className="absolute inset-0">
                <div className="mx-auto flex h-full max-w-7xl items-center px-4 sm:px-6 lg:px-8">
                  <div className="max-w-xl">
                    <p className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-xs font-semibold text-white ring-1 ring-white/15 backdrop-blur">
                      <span className="h-2 w-2 rounded-full bg-emerald-400" />
                      {s.badge}
                    </p>

                    <h1 className="mt-4 text-3xl font-extrabold tracking-tight text-white sm:text-5xl">
                      {s.title}
                    </h1>

                    <p className="mt-4 max-w-lg text-sm text-zinc-200 sm:text-base">
                      {s.desc}
                    </p>

                    <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
                      <NavLink
                        to={s.primaryTo}
                        className="inline-flex items-center justify-center rounded-2xl px-5 py-3 text-sm font-extrabold bg-emerald-500 text-white hover:bg-emerald-400 transition focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400/70 focus-visible:ring-offset-2 focus-visible:ring-offset-zinc-950"
                      >
                        {s.primaryText}
                      </NavLink>

                      <NavLink
                        to={s.secondaryTo}
                        className="inline-flex items-center justify-center rounded-2xl px-5 py-3 text-sm font-extrabold bg-white/10 text-white ring-1 ring-white/15 hover:bg-white/15 transition focus:outline-none focus-visible:ring-2 focus-visible:ring-white/40 focus-visible:ring-offset-2 focus-visible:ring-offset-zinc-950"
                      >
                        {s.secondaryText}
                      </NavLink>
                    </div>

                    <div className="mt-7 flex flex-wrap gap-2">
                      {(s.perks || []).map((label, idx) => (
                        <span
                          key={idx}
                          className="rounded-2xl bg-white/10 px-4 py-2 text-xs font-semibold text-white ring-1 ring-white/10 backdrop-blur"
                        >
                          {label}
                        </span>
                      ))}
                    </div>

                    <p className="mt-3 text-[11px] text-zinc-400">
                      *Tergantung produk/creator.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Arrows */}
      {items.length > 1 && (
        <>
          <button
            type="button"
            onClick={goPrev}
            className="absolute left-3 top-1/2 -translate-y-1/2 rounded-2xl bg-black/40 px-3 py-2 text-white ring-1 ring-white/10 backdrop-blur hover:bg-black/55 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/30"
            aria-label="Previous slide"
          >
            ‹
          </button>
          <button
            type="button"
            onClick={goNext}
            className="absolute right-3 top-1/2 -translate-y-1/2 rounded-2xl bg-black/40 px-3 py-2 text-white ring-1 ring-white/10 backdrop-blur hover:bg-black/55 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/30"
            aria-label="Next slide"
          >
            ›
          </button>
        </>
      )}

      {/* Dots */}
      {items.length > 1 && (
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2">
          <div className="flex items-center gap-2 rounded-full bg-black/30 px-3 py-2 ring-1 ring-white/10 backdrop-blur">
            {items.map((_, i) => (
              <button
                key={i}
                type="button"
                onClick={() => setActive(i)}
                className={[
                  "h-2.5 w-2.5 rounded-full transition",
                  i === active ? "bg-white" : "bg-white/35 hover:bg-white/60",
                ].join(" ")}
                aria-label={`Go to slide ${i + 1}`}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const Home = () => {
  return (
    <section className="bg-zinc-950">
      {/* FULL-BLEED wrapper (no max-w) */}
      <div className="w-full py-10">
        <PromoBannerSlider />
      </div>
    </section>
  );
};

export default Home;
